// ** Modules
import { useQuery } from '@apollo/client/react';
import { gql, type TypedDocumentNode } from '@apollo/client';

// ** Types
import type { Query } from '@/types/graphql';

export const getDashboardConsultingQuery: TypedDocumentNode<Pick<Query, 'dashboardConsulting'>> = gql`
	query DashboardConsulting($cobraId: ID!) {
		dashboardConsulting(cobraId: $cobraId) {
			cobraId
			createdAt
			createdBy
			modifiedAt
			modifiedBy
			consultant
			thema1
			thema2
			thema3
			consultingPlace
			consultingReport
			file
			consultantFirstName
			consultantLastName
			vintage
			currentNumber
			duration
			travelingTime
			preparationAndFollowUpTime
			totalDuration
			fundingAmountNrw
			federalFundngAmount
			deminimisDeclarationNumber
			employedEmployees
			trade
			consultantNumber
			themaNumber1
			themaNumber2
			themaNumber3
			placeNumber
			placeholder
			status
			referenceNumberNrw
			referenceNumberFederal
			existingBusiness
			gender
			themaText1
			themaText2
			themaText3
			placeText
			reportMessage
			warningTooManyHours
			infoAboutPolluters
			existingBusinessShort
			startUpBrief
			unlockedBy
			consultingType
			startDate
			endDate
			year
			deminimisDeclarationYear
			dateNoticeFederal
			dateNoticeNrw
			cancelledStatus
			obligation
			currentDataSet
			deminimisDeclarationYesNo
			countryOnly
			federalStateOnly
			duplication
			consultingAssignment
			itIsOn
			targetConceptMeasures
			informationSource
			comments
			startPlusMonths
			totalDurationConsultingAndParticipants
			totalDurationWorkingDay
			totalDurationWorkingDayAndPartecipantRecipent
			federalFundingAmountAndConsultationParticipant
			numberOfParticipants
			fundingAmountCountryAndConsultationParticipant
			fundingAmountTotalAndConsultationParticipant
			federalFundingAmount
			nrwFundingAmount
		}
	}
`;

export const getUserDashboardQuery: TypedDocumentNode<Pick<Query, 'userDashboard'>> = gql`
	query DashboardUser($userId: ID!) {
		userDashboard(userId: $userId) {
			person {
				name {
					fullName
					firstName
					lastName
				}
				address {
					street
					houseNumber
					postalCode
					city
				}
				contactData {
					email,
					mobilePhone,
					phone
				}
			}
			company {
				companyName
			}
			billing {
				invoiceAddress {
					street
					houseNumber
					postalCode
					city
				}
			}
		}
	}
`;

// TODO: Get About Us Team
export const useGetDashboardConsulting = (cobraId: number) => {
	const props = useQuery(getDashboardConsultingQuery, {
		variables: { cobraId },
		skip: !cobraId || cobraId === null
	});

	const data: Pick<Query, 'dashboardConsulting'> = props.data ?? { dashboardConsulting: [] };
	return { ...props, data };
};

export const useGetDashboardUserData = (userId: number) => {
	const props = useQuery(getUserDashboardQuery, {
		variables: { userId },
		skip: !userId || userId === null
	});

	const data: Pick<Query, 'userDashboard'> = props.data ?? ({} as Pick<Query, 'userDashboard'>);
	return { ...props, data };
};
